import { Modal } from '@mui/material'
import IonIcon from '@reacticons/ionicons'
import { FilterOption } from 'src/types'

import { SearchField } from '../global/SearchField'
import { Sidebar } from '../global/Sidebar'

interface FilterDialogProps {
  showFilterDlg: boolean
  setShowFilterDlg: (value: boolean) => void
  filterProps: FilterOption[]
}

/**
 * Primary UI component for user interaction
 */
export const FilterDialog: React.FC<FilterDialogProps> = ({ showFilterDlg, setShowFilterDlg, filterProps }) => {
  return (
    <Modal open={showFilterDlg}>
      <div className="flex flex-col w-full h-full bg-white p-[17px]">
        <div className="flex flex-row mb-[13px]">
          <p className="font-secondary font-bold text-[20px] text-darkgray items-center">Filter</p>
          <div className="ml-auto" onClick={() => setShowFilterDlg(false)}>
            <IonIcon name="close-outline" className="!h-[30px] !w-[30px] text-[black]" />
          </div>
        </div>
        <SearchField className="mb-[23px]" />
        <Sidebar filterOptions={filterProps} defaultSelectFilterIdx={1} />
        <button
          className="text-white font-secondary text-[14px] font-bold text-center rounded-[22.5px] px-[25px] bg-navy mt-auto mb-[15px] h-[50px] !important"
          onClick={() => setShowFilterDlg(false)}
        >
          Apply Filters
        </button>
      </div>
    </Modal>
  )
}
